// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oc-tag-header {
  border-bottom: 1px solid #ebebeb;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  align-items: flex-start;
}

.tag-candidate-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0a56ae;
  border-radius: 3px;
  color: #fff;
  height: 60%;
  font-size: 9px;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px;
  padding-bottom: 1px;
}

.job-tagging-header-info-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
}

.job-tagging-header-info,
.job-tagging-header-info-2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 10px;
  color: #0a56ae;
}

.job-tagging-header-info-2 {
  column-gap: 5px;
  font-size: 10px;
}

.job-name-header {
  font-size: 14px;
  font-weight: 500;
  color: #000;
}

@media (min-width: 1366px) {
  .job-name-header {
    font-size: 17px;
  }

  .tag-candidate-badge {
    font-size: 12px;
  }

  .job-tagging-header-info-2 {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./../job/src/components/JobOverview/JobOverviewTag/JobOverviewTag.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,QAAA;AAEF;;AACA;;EAEE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,eAAA;EACA,eAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAEF;;AACA;EACE;IACE,eAAA;EAEF;;EACA;IACE,eAAA;EAEF;;EACA;IACE,eAAA;EAEF;AACF","sourcesContent":[".oc-tag-header {\n  border-bottom: 1px solid rgb(235, 235, 235);\n  padding-top: 10px;\n  padding-bottom: 10px;\n  display: flex;\n  align-items: flex-start;\n}\n.tag-candidate-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #0a56ae;\n  border-radius: 3px;\n  color: #fff;\n  height: 60%;\n  font-size: 9px;\n  padding-left: 4px;\n  padding-right: 4px;\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n\n.job-tagging-header-info-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 4px;\n}\n\n.job-tagging-header-info,\n.job-tagging-header-info-2 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  column-gap: 10px;\n  color: #0a56ae;\n}\n\n.job-tagging-header-info-2 {\n  column-gap: 5px;\n  font-size: 10px;\n}\n\n.job-name-header {\n  font-size: 14px;\n  font-weight: 500;\n  color: #000;\n}\n\n@media (min-width: 1366px) {\n  .job-name-header {\n    font-size: 17px;\n  }\n\n  .tag-candidate-badge {\n    font-size: 12px;\n  }\n\n  .job-tagging-header-info-2 {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
